module.exports = __webpack_public_path__ + "img/logo-backoffice.9fb2160f.svg";